import { ActionIcon } from '@mantine/core';

export default ActionIcon.extend({
  defaultProps: {
    color: 'gray.6',
  },
});
